<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
          <v-data-table
          :headers="headersProducts"
          :items="products"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.organization }}</td>
            <td>{{ props.item.category.name }}</td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="deleteProductDialog(props.item)">
                  <v-icon color="blue">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="my-5">
      <v-flex xs12>
          <v-data-table
          :headers="headersUsers"
          :items="users"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.organization }}</td>
            <td>{{ props.item.username }}</td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="authorizeDialog(props.item)">
                  <v-icon v-if="props.item.auth" color="green">person</v-icon>
                  <v-icon v-else color="red">person</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteUserDialog(props.item)">
                <v-icon color="blue">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-text>{{ dialogText }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue" flat @click.native="dialog = false">Cancelar</v-btn>
            <v-btn color="blue" flat @click.native="acceptDialog">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'

export default {
  name: 'Admin',
  data: () => ({
    headersProducts: [
      { text: 'Título',
        sortable: false,
        value: 'title' },
      { text: 'Organización',
        sortable: false,
        value: 'organization' },
      { text: 'Categoria',
        sortable: false,
        value: 'category' },
      { text: 'Acciones', value: 'action', sortable: false }
    ],
    headersUsers: [
      { text: 'Email',
        sortable: false,
        value: 'email' },
      { text: 'Organización',
        sortable: false,
        value: 'organization' },
      { text: 'Usuario',
        sortable: false,
        value: 'username' },
      { text: 'Acciones', value: 'action', sortable: false }
    ],
    products: [],
    users: [],
    dialog: false,
    dialogText: '',
    item: null,
    dialogType: null
  }),
  created () {
    this.getProducts()
    this.getUsers()
  },
  methods: {
    getProducts () {
      HTTP.get('/product/getAll')
        .then(function (response) {
          this.products = response.data.result
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    getUsers () {
      HTTP.get('/user/getAll')
        .then(function (response) {
          this.users = response.data.result
          let me = this.users.find((item) => { return item._id === this.$store.getters.getUser._id })
          let index = this.users.indexOf(me)
          this.users.splice(index, 1)
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    deleteProductDialog (item) {
      this.item = item
      this.dialogText = '¿Seguro que quieres borrar este producto?'
      this.dialogType = 'product'
      this.dialog = true
    },
    deleteUserDialog (item) {
      this.item = item
      this.dialogText = '¿Seguro que quieres borrar este usuario?'
      this.dialogType = 'user'
      this.dialog = true
    },
    authorizeDialog (item) {
      this.item = item
      this.dialogText = this.item.auth ? '¿Seguro que quieres desautorizar a este usuario?' : '¿Seguro que quieres dar autorización a este usuario?'
      this.dialogType = 'authorize'
      this.dialog = true
    },
    acceptDialog () {
      this.dialog = false
      if (this.dialogType === 'product') this.deleteProduct()
      if (this.dialogType === 'user') this.deleteUser()
      if (this.dialogType === 'authorize') this.authorizeUser()
    },
    deleteProduct () {
      HTTP.get('/product/delete/' + this.item._id)
        .then(function (response) {
          this.getProducts()
          this.$bus.$emit('event-toast', 'Producto borrado')
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    deleteUser () {
      HTTP.get('/user/delete/' + this.item._id)
        .then(function (response) {
          this.getUsers()
          this.$bus.$emit('event-toast', 'Usuario borrado')
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    authorizeUser () {
      let requestAuthUser = {
        auth: !this.item.auth
      }
      HTTP.post('/user/authorize/' + this.item._id, requestAuthUser)
        .then(function (response) {
          this.getUsers()
          this.$bus.$emit('event-toast', response.data.message)
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue